import { Component, OnInit, OnDestroy } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";
import { LoadingOverlayService } from "../../../services/loading-overlay/loading-overlay.service";
import { Validators } from "@angular/forms";
import { DecimalFormatterService } from "../../../helpers/decimal-formatter.service";
import { FormlyHelper } from "../../../helpers/formly-helper";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { OperationalFileExchangeRateDTO } from "../../../services/swagger-gen/fordesk/model/operationalFileExchangeRateDTO";
import { CurrencyDTO } from "../../../services/swagger-gen/fordesk";

@Component({
  selector: "exchange-rate-input",
  templateUrl: "./exchange-rate-input.component.html",
  styleUrls: ["./exchange-rate-input.component.scss"]
})
export class ExchangeRateInputComponent extends FieldArrayType implements OnInit, OnDestroy {

  public submitted: boolean;
  public operationalFileId: number;
  private unsubscribe: Subject<void> = new Subject();
  private isRequired: boolean = false;

  public exchangeRates: OperationalFileExchangeRateDTO[];
  public currencies: CurrencyDTO[];
  public applicationCurrency: CurrencyDTO;
  public mappedExchangeRates: ExchangeRateOptions[];

  constructor(
    private overlay: LoadingOverlayService,
    public formatService: DecimalFormatterService,
    public formlyHelper: FormlyHelper,
  ) {
    super();
  }

  public ngOnInit() {
    this.formlyHelper
      .getGeneralFormSubmission$()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => this.submitted = true);

    this.currencies = this.field.templateOptions["currencies"];
    this.exchangeRates = this.field.templateOptions["exchangeRates"];
    this.applicationCurrency = this.field.templateOptions["applicationCurrency"];

    this.mappedExchangeRates = this.exchangeRates.map(rate => ({
      exchangeRate: rate.exchangeRate,
      currencyFrom: this.currencies.find(c => c.id === rate.currencyFromId),
      generalCurrency: this.applicationCurrency,
    } as ExchangeRateOptions));

    if (this.field.templateOptions.required) {
      this.formControl.setValidators([Validators.required]);
      this.isRequired = true;
    } else {
      this.formControl.setValidators(null);
    }

    this.overlay.stopLoading();
  }


  public ngOnDestroy(): void {
    if (!this.unsubscribe || !this.unsubscribe.observers || this.unsubscribe.observers.length <= 0) {
      return;
    }

    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}


export class ExchangeRateOptions {
  exchangeRate: number;
  currencyFrom: CurrencyDTO;
  generalCurrency: CurrencyDTO;
}
